import FArray from '@/plugins/form/FArray';
import Item from './Item';

export default class extends FArray {
  constructor(props) {
    super(props);
    this.tour = props.parent;
  }

  get options() {
    return this.items.map((i, j) => ({
      value: i.tariffId,
      label: i.name.value || `Тариф ${j + 1}`,
    }));
  }

  get data() {
    return this.items.map(i => i.data);
  }
  remove(item) {
    this.tour.services.deleteServicePrice(item);
    super.remove(item);
  }
  set data(value) {
    this.__value = [];
    value.forEach((i) => {
      const item = new Item();
      this.push(item);
      item
        .setData(i)
        .init();
    });
  }

  add() {
    const item = new Item();
    this.push(item);
    return item.set()
      .init();
  }
}
